<div class="table-wrapper ui basic segment">

  <div class="ui basic center aligned segment">
    <div class="ui compact message">
      <div class="header">
        <p>
          Please note that you will not be allowed to make modifications after attempting payment
        </p>
      </div>
    </div>
  </div>

  <div class="ng-wrap ui basic segment">

    <!---->
    <div class="full-width ui basic segment">
      <div class="ui basic segment">

        <h2 class="ui header center aligned">
          Remita RRR: 
          <app-progress-spinner [isLoading]="isLoading" [classes]="'black'"></app-progress-spinner>
          {{ remita?.rrr }}
        </h2>

        <p>
          {{errorMessage}}
        </p>
        
        <h2 class="ui header center aligned">
          {{ remita?.amount  | currency :'₦':'symbol':'1.2-2' }}
        </h2>

        <!---->
        <div class="ui basic segment">
          <!---->
          <table class="ui table">
            <thead>
              <tr>
                <th class="ten wide">Description</th>
                <th class="right aligned six wide">Amount</th>
              </tr>
            </thead>
            <tbody>
              <!---->
              <tr *ngFor="let row of paymentInfo.paymentDue">
                <td class="eight wide">{{ row?.name | uppercase }}</td>
                <td class="eight wide right aligned">
                  {{ row?.amount  | currency :'₦':'symbol':'1.2-2' }}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="ui horizontal divider">
          Pay via
        </div>

        <div class="payment-platform-items">
          <div class="payment-platform">
            <form ngNoForm action="{{remita?.gatewayUrl}}" id="remita_form2" name="remita_form2"
              method="POST">
              <input type="hidden" id="merchantId" name="merchantId"
                [(ngModel)]="remita.merchantId" />
              <input type="hidden" id="rrr" name="rrr" [(ngModel)]="remita.rrr" />
              <input type="hidden" id="responseurl" name="responseurl" [(ngModel)]="remita.responseurl" />
              <input type="hidden" id="hash" name="hash" [(ngModel)]="remita.hashInit" />

              <div class="ui two column centered grid">
                <div class="four column centered row">
                  <div class="column">
                    <button (click)="goBack()" type="button" class="ui labeled icon button primary">
                      <i class="left chevron icon"></i>
                      Back
                    </button>
                  </div>
                  <div class="column payment-platform">
                    <button type="submit" class="ui orange massive image label" target="_blank">
                      <img src="./assets/images/remita-payment-logo-vertical.png"> Remita
                    </button>
                  </div>
                </div>
              </div>

            </form>


          </div>
        </div>
      </div>
    </div>

  </div>

</div>
